import { Directive } from "@angular/core";
import { BasePageContent } from "../../../core/content/base-page-content.component";

export class PagecontentSearchResultPage extends BasePageContent {
  getPageSpecificText() {
    this.PAGE_TEXT["cgp"] = {
      lbl_return: "Return to Search",

      lbl_ltf: `LTF ID#:`,
      lbl_date_submit: `Date Submitted:`,
      lbl_ltf_status: `LTF Status:`,

      lbl_permit_info: `Permit Information`,
      lbl_permit_type: `Permit Type:`,
      lbl_date_applied: `Date Applied:`,
      lbl_project_type: `Project Type:`,

      lbl_owner_name: `Owner:`,
      lbl_company_name: `Company Name:`,
      lbl_company_address: `Company Address:`,

      lbl_date_issued: `Issue Date:`,
      lbl_authcode: `Authorization Code:`,

      lbl_const_info: `Construction Information`,
      lbl_date_start: `Start Date:`,
      lbl_date_end: `End Date:`,
      lbl_common_area: `Common Area:`,

      lbl_siteName: `Project/Site Name:`,
      lbl_facility_name: `Facility Name:`,
      lbl_facility_address: `Facility Address:`,
      lbl_facility_county: `County:`,

      lbl_outfalls: `Outfalls:`,
      lbl_total_proj_area: `Total Area (in acres):`,
      lbl_permit_proj_area: `Project Area (in acres):`,

      lbl_swwp_info: `SWPPP Information`,
      lbl_contact: `Contact Name:`,
      lbl_email: `Email:`,
      lbl_phone: `Phone:`,

      lbl_lat: `Latitude`,
      lbl_lng: `Longitude`,
    };
  }
}
